import { render, staticRenderFns } from "./AppSelection.vue?vue&type=template&id=150ae227&scoped=true&"
import script from "./AppSelection.vue?vue&type=script&lang=js&"
export * from "./AppSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150ae227",
  null
  
)

export default component.exports